import { render, staticRenderFns } from "./MyDocuments.vue?vue&type=template&id=ad86d7a0&scoped=true&"
import script from "./MyDocuments.vue?vue&type=script&lang=js&"
export * from "./MyDocuments.vue?vue&type=script&lang=js&"
import style0 from "./MyDocuments.vue?vue&type=style&index=0&id=ad86d7a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad86d7a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad86d7a0')) {
      api.createRecord('ad86d7a0', component.options)
    } else {
      api.reload('ad86d7a0', component.options)
    }
    module.hot.accept("./MyDocuments.vue?vue&type=template&id=ad86d7a0&scoped=true&", function () {
      api.rerender('ad86d7a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/docDigital/MyDocuments.vue"
export default component.exports